/**
 * These products labels can be for the entire app at the time of
 * initialising `constants/config`
 */

export const LE_FLASH_HOTEL_PRODUCT_LABEL = 'Limited Time LUX Exclusive'
export const FLASH_HOTEL_PRODUCT_LABEL = 'Limited Time Exclusive'

export const LE_TAO_HOTEL_PRODUCT_LABEL = 'LUX Premium Collection'
export const TAO_HOTEL_PRODUCT_LABEL = 'Premium Collection'

export const LE_TOUR_PRODUCT_LABEL = ''
export const TOUR_PRODUCT_LABEL = ''

export const LE_TOUR_V2_PRODUCT_LABEL = ''
export const TOUR_V2_PRODUCT_LABEL = ''

export const LE_CRUISE_PRODUCT_LABEL = ''
export const CRUISE_PRODUCT_LABEL = ''

/**
 * @deprecated Use `useProductLabels` from `hooks/useProductLabels` for localized product labels in React components.
 */
export const LE_LME_HOTEL_PRODUCT_LABEL = ''
/** @deprecated Use `useProductLabels` from `hooks/useProductLabels` for localized product labels in React components. */
export const LME_HOTEL_PRODUCT_LABEL = 'Last Minute Escape'

/**
 * @deprecated Use `useProductLabels` from `hooks/useProductLabels` for localized product labels in React components.
 */
export const LE_LPP_PRODUCT_LABEL = 'LUX Partner Property'
/** @deprecated Use `useProductLabels` from `hooks/useProductLabels` for localized product labels in React components. */
export const LPP_PRODUCT_LABEL = 'Partner Property'
